module.exports = __webpack_public_path__ + "img/pr-4.10a12e54.png";